"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingExperienceQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FalconSelectQuestionWidgetBase_1 = require("../../FalconSelectQuestionWidgetBase");
var portal_core_1 = require("@ferry/portal-core");
var DrivingExperienceQuestionWidget = /** @class */ (function (_super) {
    __extends(DrivingExperienceQuestionWidget, _super);
    function DrivingExperienceQuestionWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLicenceChangeHeadsUpPopup = function () {
            return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Heads up -", (0, jsx_runtime_1.jsx)("strong", { children: " If you have changed your EU Licence to a UK Licence" }), " and DIDN'T have to take a UK Driving Test, you can", (0, jsx_runtime_1.jsx)("strong", { children: " declare you've held your UK licence for the same number of years" }), " as your EU one."] }) }));
        };
        _this.renderInputField = function () {
            return ((0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsxs)("select", { id: _this.props.question.name, className: "form-control ".concat(_this.getInputValidationClass()), onChange: _this.handleOnChangeEvent, onFocus: _this.executeNativeEvent, onBlur: _this.handleOnBlurEvent, onClick: _this.executeNativeEvent, onDoubleClick: _this.executeNativeEvent, disabled: _this.getSetting(DrivingExperienceQuestionWidget.inputDisabledSetting, false) || _this.isReadOnly(), value: _this.getValue(), children: [(0, jsx_runtime_1.jsx)("option", { value: '', children: _this.props.question.placeHolder ? _this.props.question.placeHolder : "Please select..." }), _this.state.lookupValues && _this.state.lookupValues.map(function (lookupItem) {
                            var className = lookupItem.value.replace(/ /g, '_').toLocaleLowerCase();
                            return ((0, jsx_runtime_1.jsx)("option", { className: className, value: lookupItem.id, children: _this.renderHtml(lookupItem.value) }, lookupItem.id));
                        })] }) }));
        };
        _this.getValue = function () {
            var interactionFieldValue = _this.bindFromField(_this.props.question.interactionField);
            if (interactionFieldValue === undefined || interactionFieldValue === null) {
                return "";
            }
            return interactionFieldValue;
        };
        _this.handleOnChangeEvent = function (event) {
            _this.validateInternal(event.target.value);
            _super.prototype.handleOnChangeEvent.call(_this, event);
        };
        return _this;
    }
    DrivingExperienceQuestionWidget.prototype.render = function () {
        var title = this.renderHtml(this.getSetting(DrivingExperienceQuestionWidget.questionTitle, ""));
        var driverInteractionField = this.props.question.interactionField.split('.')[0];
        var oldDrivingLicenceType = this.bindFromField(driverInteractionField + ".licence.oldType");
        var newDrivingLicenceType = this.bindFromField(driverInteractionField + ".licence.type");
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "drivingExperience", children: title }), ((oldDrivingLicenceType == "4" || oldDrivingLicenceType == "5") && (newDrivingLicenceType == "1" || newDrivingLicenceType == "2" || newDrivingLicenceType == "3")) && this.renderLicenceChangeHeadsUpPopup(), this.renderInputField()] }));
    };
    DrivingExperienceQuestionWidget.inputDisabledSetting = "inputDisabled";
    DrivingExperienceQuestionWidget.questionTitle = "htmlLabel";
    return DrivingExperienceQuestionWidget;
}(FalconSelectQuestionWidgetBase_1.FalconSelectQuestionWidgetBase));
exports.DrivingExperienceQuestionWidget = DrivingExperienceQuestionWidget;
//# sourceMappingURL=DrivingExperienceQuestionWidget.js.map